import { displayShopFact } from '@/i18n/catalogDisplayText';
import { fixedUi } from '@/i18n/fixedUi';
import React from 'react';
import { countSiteRows, flattenSiteRows } from '@/shein-platform/utils/sheinSiteList';

export default function ShopSiteListPanel({
  loading,
  error,
  siteList,
}) {
  const rows = flattenSiteRows(siteList);
  const siteCount = countSiteRows(siteList);

  return (
    <div className="spo-shop-info__panel" data-testid="shein-site-list">
      {loading ? <p className="spo-return-detail__empty">{fixedUi("正在加载站点信息…")}</p> : null}
      {error ? <p className="spo-shop-info__inline-error" role="alert">{error}</p> : null}

      {!loading && !error && siteCount === 0 ? (
        <p className="spo-return-detail__empty">{fixedUi("暂无站点数据，请点击右上角「同步店铺信息」从 SHEIN 同步。")}</p>
      ) : null}

      {!loading && !error && rows.length > 0 ? (
        <div className="spo-shop-info__table-wrap">
          <table className="spo-shop-info__table">
            <thead>
              <tr>
                <th>{fixedUi("主站点")}</th>
                <th>{fixedUi("子站点")}</th>
                <th>{fixedUi("站点缩写")}</th>
                <th>{fixedUi("状态")}</th>
                <th>{fixedUi("店铺模式")}</th>
                <th>{fixedUi("币种")}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.key}>
                  <td>{displayShopFact(row.mainSiteName) || '—'}</td>
                  <td>{displayShopFact(row.siteName)}</td>
                  <td><code>{row.siteAbbr}</code></td>
                  <td>{displayShopFact(row.siteStatus)}</td>
                  <td>{displayShopFact(row.storeType)}</td>
                  <td>{row.currency}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
